<template>
<div>
  <div class="contenedor_tabla-titulo" id="lineadetiempo">
    <img src="@/assets/chile_jjoo.jpg" class="img_logo_chilejjoo" />
    <h4>Chile en los Juegos Olímpicos</h4>
  </div>
  <div class="container">
    <div class="row">
      <vue-horizontal-timeline :items="items" min-width="250px" />
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: "Atenas 1896",
          content:
            "En la primera edición de los JJOO contemporáneos, Chile llevó un único competidor: el velocista Luis Subercaseaux, de 13 años. Participaron 14 países y el nuestro fue el único de Iberoamérica."
        },
        {
          title: "Estocolmo 1912",
          content:
            "Después de ausentarse en tres ediciones, Chile envía su primera delegación de 14 deportistas que compitieron en múltiples disciplinas, como atletismo, ciclismo, ecuestre y tiro."
        },
        {
          title: "Amberes 1920",
          content:
            "La delegación chilena se reduce a dos deportistas que compitieron en atletismo: Arturo Medina, puesto 16 en la ronda clasificatoria de la jabalina; y Juan Jorquera, 33° en maratón."
        },
        {
          title: "París 1924",
          content:
            "Con 13 atletas representando a Chile, el boxeador Carlos Abarca y el maratonista Manuel Plaza consiguen las primeras posiciones puntuables: quinto y sexto lugar, respectivamente."
        },
        {
          title: "Ámsterdam 1928",
          content:
            "Manuel Plaza logra la primera medalla olímpica para Chile: plata en maratón. El mito dice que no ganó el oro porque se extravió en el camino, pero fue un dolor de rodilla lo que jugó en su contra."
        },
        {
          title: "Berlín 1936",
          content:
            "Compite la primera chilena a una cita olímpica: Raquel Martínez, en los 100 metros planos. También fue la primera sudamericana en el atletismo. Chile envió 40 deportistas."
        },
        {
          title: "Londres 1948",
          content:
            "Chile llevó una delegación de 56 deportistas a la primera edición después de la II Guerra Mundial. Entre ellos, 15 atletas y el segundo más joven en unos JJOO: el clavadista Günther Mund (13 años)."
        },
        {
          title: "Helsinki 1952",
          content:
            "Con 58 deportistas, es la delegación nacional más numerosa en la historia. Oscar Cristi y su caballo Bambi obtuvieron doble medalla de plata, en salto por equipos y en salto individual."
        },
        {
          title: "Melbourne 1956",
          content:
            "Chile obtuvo la mayor cantidad de medallas en su historia, con dos de bronce y dos de plata: tres fueron en boxeo y Marlene Ahrens logró plata en jabalina. Es la única mujer medallista del país."
        },
        {
          title: "Roma 1960",
          content:
            "Se presenta la delegación más pequeña desde 1920, solo nueve atletas. Chile comenzó en Italia una sequía de medallas olímpicas que duró hasta 1988."
        },
        {
          title: "Tokio 1964",
          content:
            "Compitieron 14 deportistas de nuestro país. Después de cinco ediciones con participación de mujeres, la delegación vuelve a componerse solamente por hombres."
        },
        {
          title: "México 1968",
          content:
            "En total 21 deportistas integraron la delegación chilena: 19 hombres y dos mujeres distribuidos en cuatro disciplinas: atletismo, boxeo, equitación y tiro al vuelo."
        },
        {
          title: "Múnich 1972",
          content:
            "En los Juegos Olímpicos marcados por el atentado a la delegación israelí, Chile llevó solo 11 deportistas, entre los que destacó el joven Martín Vargas."
        },
        {
          title: "Montreal 1976",
          content:
            "El Team Chile se compuso por apenas siete deportistas, entre los que destacó Richard Tormen, ciclista que finalizó noveno en el sprint masculino."
        },
        {
          title: "Los Ángeles 1984",
          content:
            "Luego de seis olimpiadas, el fútbol chileno volvió a estar en los JJ.OO. y, la delegación sumó 52 deportistas (solo dos mujeres). La Roja llegó a cuartos y fue eliminada por Italia."
        },
        {
          title: "Seúl 1988",
          content:
            "Chile llevó a 17 deportistas, entre los que destacó Alfonso de Iruarrizaga, medallista de plata en tiro skeet. Luego de 32 años, Chile sumaba otra presea."
        },
        {
          title: "Barcelona 1992",
          content:
            "Solo 12 competidores representaron a Chile. Destaca la participación de Paulina Sepúlveda, primera tenista mujer de Chile en competir en unos Juegos."
        },
        {
          title: "Atlanta 1996",
          content:
            "Con 21 atletas, Chile estuvo presente en 10 disciplinas. Esta fue la primera participación de Érika Olivera. La maratonista tiene el récord nacional de Juegos Olímpicos, con cinco participaciones."
        },
        {
          title: "Sydney 2000",
          content:
            "Tras 12 años, Chile vuelve a ganar una medalla. La Selección Sub-23 de Nelson Acosta, reforzada con Pedro Reyes, Nelson Tapia e Iván Zamorano, derrotó a EE.UU. y se quedó con el bronce."
        },
        {
          title: "Atenas 2004",
          content:
            "La edición más exitosa en la historia del deporte olímpico nacional. En dobles, Nicolás Massú y Fernando González le dieron el primer oro a Chile. Se sumaron un bronce de González y otro oro de Massú en singles. “El Vampiro” es el único tenista en la historia con doble medalla de oro."
        },
        {
          title: "Beijing 2008",
          content:
            "Llegaron 26 deportistas y fue la última edición con medallas para Chile: Fernando González obtuvo plata en tenis tras caer ante Rafael Nadal. Es el único chileno que tiene las tres medallas olímpicas."
        },
        {
          title: "Londres 2012",
          content:
            "Chile presentó 35 atletas. En estos Juegos, Tomás González se posicionó como el mejor gimnasta en la historia de nuestro país, al rozar el podio con un cuarto lugar en suelo y salto."
        },
        {
          title: "Río 2016",
          content:
            "Bárbara Riveros logró la mejor posición olímpica del triatlón chileno: quinto lugar. También destacó María Fernanda Valdés, séptima en la categoría 75 kg de la halterofilia."
        },
        {
          title: "Tokio 2020",
          content:
            "Debido a la pandemia del covid-19 los Juegos Olímpicos de Tokio se aplazaron para 2021. Chile consolidó un equipo de 58 deportistas en 23 disciplinas. Destaca La Roja femenina, primer equipo de mujeres en deporte colectivo."
        }
      ]
    }
  }
}
</script>